module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/manual-placement.9726886b.svg";